import { css } from '@emotion/react';

export default ({ addNewLine, multiline }) => [
  addNewLine &&
    css`
      margin-bottom: 1em;
    `,
  multiline &&
    css`
      white-space: pre-wrap;
      word-wrap: break-word;
    `,
];
